import { z } from "zod"

import {
  fieldChangeOrderPolicyProjectionV1Schema,
  fieldChangeOrderProposalProjectionV1Schema,
} from "./field-change-order-v1.js"
import {
  fieldProjectionV2Schema,
  fieldVisitProjectionV2Schema,
} from "./field-projection-v2.js"

export const fieldVisitProjectionV3Schema = fieldVisitProjectionV2Schema.extend({
  changeOrderPolicy: fieldChangeOrderPolicyProjectionV1Schema,
  changeOrderProposals: z.array(
    fieldChangeOrderProposalProjectionV1Schema,
  ).max(25),
}).strict()

export const fieldProjectionV3Schema = z.object({
  ...fieldProjectionV2Schema.shape,
  responseVersion: z.literal(3),
  visits: z.array(fieldVisitProjectionV3Schema).max(100),
}).strict().superRefine((projection, context) => {
  const generated = Date.parse(projection.generatedAt)
  const expires = Date.parse(projection.expiresAt)
  if (expires <= generated || expires - generated > 15 * 60 * 1_000) {
    context.addIssue({
      code: "custom",
      message: "Field projection expiry must be within 15 minutes.",
      path: ["expiresAt"],
    })
  }
  const start = Date.parse(`${projection.horizonStartDate}T00:00:00Z`)
  const end = Date.parse(`${projection.horizonEndDate}T00:00:00Z`)
  if (end - start !== 2 * 24 * 60 * 60 * 1_000) {
    context.addIssue({
      code: "custom",
      message: "Field projection horizon must be today and the next day.",
      path: ["horizonEndDate"],
    })
  }
  if (
    new Set(projection.visits.map((visit) => visit.visitId)).size !==
    projection.visits.length
  ) {
    context.addIssue({
      code: "custom",
      message: "Field projection Visits must be unique.",
      path: ["visits"],
    })
  }
  if (
    projection.workShift &&
    !projection.relationships.some(
      (relationship) =>
        relationship.relationshipId === projection.workShift?.relationshipId &&
        relationship.legalEntityId === projection.workShift.legalEntityId,
    )
  ) {
    context.addIssue({
      code: "custom",
      message: "Active Work Shift must use a current relationship.",
      path: ["workShift"],
    })
  }
  if (
    projection.visitTime &&
    (!projection.workShift ||
      projection.visitTime.workShiftId !== projection.workShift.workShiftId)
  ) {
    context.addIssue({
      code: "custom",
      message: "Visit Time must be nested in the active Work Shift.",
      path: ["visitTime"],
    })
  }
})

export type FieldProjectionV3 = z.infer<typeof fieldProjectionV3Schema>
export type FieldVisitProjectionV3 = z.infer<
  typeof fieldVisitProjectionV3Schema
>
